export enum VEHICLE_TYPES {
  MOTORCYCLE = "moto",
}

export enum VEHICLE_FUEL {
  FLEX = "flex",
  ALCOHOL = "álcool",
  GASOLINE = "gasolina",
}

export enum VEHICLE_STATUS {
  MISSING_DATA = "missing_data",
  INACTIVE = "inactive",
  AVAILABLE = "available",
  RENTED = "rented",
  SELLED = "selled",
  UNDEFINED = "undefined",
  WAITING_PAYMENT = "waiting_payment",
  ADMINISTRATIVE_USE = "administrative_use",
  UNDER_PREPARATION = "under_preparation",
  UNDER_REVIEW = "under_review",
  IN_REPAIR = "in_repair",
  IN_REVISION = "in_revision",
  INSURANCE = "insurance",
  IMPOUNDED = "impounded",
  THIRD_PARTY_INSURANCE = "third_party_insurance",
  PREPARATION_FOR_SALE = "preparation_for_sale",
  USE_INTERNAL = "use_internal",
  IN_TRANSIT = "in_transit",
  THEFT_ROBBERY = "theft_robbery",
  MISAPPROPRIATION = "misappropriation",
  IN_READY_RESPONSE = "in_ready_response",
  VEHICLE_ON_RESERVED = "vehicle_reserved",
  TRIGGER_OPENING = "trigger_opening",
  REIMBURSEMENT = "reimbursement",
  REPOSSESSION = "repossession",
  TRIAGE = "triage",
  AWAITING_TRANSFER = "awaiting_transfer",
}

export const STATUS_OPTIONS: Record<
  string,
  { value: string; label: string }[]
> = {
  [VEHICLE_STATUS.UNDER_PREPARATION]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.AVAILABLE, label: "Disponível" },
  ],
  [VEHICLE_STATUS.AVAILABLE]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.TRIAGE, label: "Triagem" },
    { value: VEHICLE_STATUS.IN_TRANSIT, label: "Em trânsito" },
  ],
  [VEHICLE_STATUS.RENTED]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.IMPOUNDED, label: "Apreendido" },
    { value: VEHICLE_STATUS.MISAPPROPRIATION, label: "Apropriação indébita" },
  ],
  [VEHICLE_STATUS.TRIAGE]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.INSURANCE, label: "Abertura de acionamento" },
    {
      value: VEHICLE_STATUS.THIRD_PARTY_INSURANCE,
      label: "Acionamento de terceiros",
    },
    { value: VEHICLE_STATUS.IN_REPAIR, label: "Em manutenção" },
    { value: VEHICLE_STATUS.IN_REVISION, label: "Reparo estético" },
    { value: VEHICLE_STATUS.PREPARATION_FOR_SALE, label: "Motos para Venda" },
  ],
  [VEHICLE_STATUS.INSURANCE]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.TRIGGER_OPENING, label: "Proteção acionada" },
  ],
  [VEHICLE_STATUS.TRIGGER_OPENING]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.IN_REVISION, label: "Reparo estético" },
    { value: VEHICLE_STATUS.REIMBURSEMENT, label: "Ressarcidas" },
  ],
  [VEHICLE_STATUS.IN_REPAIR]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.AVAILABLE, label: "Disponível" },
    { value: VEHICLE_STATUS.IN_REVISION, label: "Reparo estético" },
  ],
  [VEHICLE_STATUS.UNDER_REVIEW]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.AVAILABLE, label: "Disponível" },
    { value: VEHICLE_STATUS.IN_REVISION, label: "Reparo estético" },
  ],
  [VEHICLE_STATUS.IN_REVISION]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.AVAILABLE, label: "Disponível" },
    { value: VEHICLE_STATUS.IN_REPAIR, label: "Em manutenção" },
  ],
  [VEHICLE_STATUS.PREPARATION_FOR_SALE]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.SELLED, label: "Veículo vendido" },
  ],
  [VEHICLE_STATUS.REIMBURSEMENT]: [
    { value: "", label: "-" },
    { value: VEHICLE_STATUS.SELLED, label: "Veículo vendido" },
  ],
};

export const STATUS_LABELS_VEHICLES = {
  [VEHICLE_STATUS.AVAILABLE]: "Disponível",
  [VEHICLE_STATUS.MISSING_DATA]: "Dados incompletos",
  [VEHICLE_STATUS.RENTED]: "Locado",
  [VEHICLE_STATUS.INACTIVE]: "Inativo",
  [VEHICLE_STATUS.WAITING_PAYMENT]: "Aguardando pagamento",
  [VEHICLE_STATUS.SELLED]: "Veículo vendido",
  [VEHICLE_STATUS.UNDER_PREPARATION]: "Em preparação",
  [VEHICLE_STATUS.UNDER_REVIEW]: "Revisão Programada",
  [VEHICLE_STATUS.IN_REPAIR]: "Em manutenção",
  [VEHICLE_STATUS.IN_REVISION]: "Reparo estético",
  [VEHICLE_STATUS.INSURANCE]: "Abertura de acionamento",
  [VEHICLE_STATUS.TRIGGER_OPENING]: "Proteção acionada",
  [VEHICLE_STATUS.IMPOUNDED]: "Apreendido",
  [VEHICLE_STATUS.THIRD_PARTY_INSURANCE]: "Seguro de Terceiros",
  [VEHICLE_STATUS.PREPARATION_FOR_SALE]: "Motos para Venda",
  [VEHICLE_STATUS.IN_TRANSIT]: "Em trânsito",
  [VEHICLE_STATUS.THEFT_ROBBERY]: "Furto/Roubo",
  [VEHICLE_STATUS.MISAPPROPRIATION]: "Apropriação indébita",
  [VEHICLE_STATUS.VEHICLE_ON_RESERVED]: "Moto reserva",
  [VEHICLE_STATUS.TRIAGE]: "Triagem",
};

export function getStatusLabelsVehicle(status: VEHICLE_STATUS) {
  return STATUS_LABELS_VEHICLES[status] || status;
}

export type VelotrackSettingType = {
  deviceId?: string;
  commands?: {
    commandId?: string;
    description?: string;
    command?: string;
  }[];
  nameDriver?: string;
  lastComunication?: string;
  blocked?: boolean;
  blockedDate?: Date;
};
export type PreparationImageData = {
  beforeImage: string;
  afterImage: string;
};
export type VehiclePreparationType = {
  paintingProtection: boolean;
  tracker: boolean;
  cellphoneSupport: boolean;
  phoneChargerSupport: boolean;
  engineProtection: boolean;
  trackerValidation: boolean;
  crlvDocument: boolean;
  hasSpareKey: boolean;
  nfDocument: boolean;
  insuranceStatus: boolean;
  preparator: string;
  repreparator: string;
  preparation?: { [key: string]: PreparationImageData };
  repreparation?: { [key: string]: PreparationImageData };
};

export type VehicleRedoPreparationType = {
  paintingProtection: boolean;
  tracker: boolean;
  cellphoneSupport: boolean;
  phoneChargerSupport: boolean;
  engineProtection: boolean;
  repreparator: string;
  repreparation: { [key: string]: PreparationImageData };
  hasSpareKey: boolean;
};

export type PartnerInfoType = {
  _id?: string;
  cnpj: string;
  companyName: string;
};

export type FipeInfoType = {
  fipeValue: string;
  fipeVehicleCode: string;
  fuel: string;
  consultDate: string;
  authentication: string;
  brand: {
    label: string;
    fipeId: string;
  };
  model: {
    availableYears?: {
      label: string;
      fipeId: string;
    }[];
    label: string;
    fipeId: string;
  };
  yearModel: {
    label: string;
    fipeId: string;
  };
  reference: {
    label: string;
    fipeId: string;
  };
};

export type Observation = {
  text: string;
  date: string;
  author: string;
  currentPath: string;
};

export interface IVehicle {
  _id: string;
  vehicleType: VEHICLE_TYPES;
  protectionLink?: string;
  insuranceStatus?: string;
  brand: string;
  model: string;
  fuel: VEHICLE_FUEL;
  yearModel: string;
  year: string;
  licensePlate: string;
  chassi: string;
  version: string;
  odometerLocavibe: string;
  motorNumber: string;
  renavam: string;
  color: string;
  crlv: string;
  companyId: string;
  nf: string;
  status: VEHICLE_STATUS;
  vehicleSituation: string;
  updatedAt: string;
  createdAt: string;
  availableForRent: boolean;
  vehiclePictures: {
    type: string;
    content: string;
  }[];
  velotrackSettings: VelotrackSettingType;
  fipeInfo: FipeInfoType;
  vehiclePreparing: VehiclePreparationType;
  observations: Observation[];
  partnerInfo: PartnerInfoType;
  fineUpload: string[];
  isEligibleSuaVibe: boolean;
  filesSale?: string[];
  uf: string;
  pathReimbursement?: string;
  daysAtBase?: number;
  purchasePrice?: number;
}

export const emptyVehicle = (): IVehicle => ({
  _id: "",
  vehicleType: VEHICLE_TYPES.MOTORCYCLE,
  brand: "-",
  model: "-",
  year: String(new Date().getFullYear()),
  yearModel: "32000-1",
  licensePlate: "",
  chassi: "",
  version: "",
  odometerLocavibe: "",
  motorNumber: "",
  renavam: "",
  color: "",
  companyId: "",
  availableForRent: true,
  fuel: VEHICLE_FUEL.GASOLINE,
  crlv: "",
  nf: "",
  vehiclePictures: [
    { type: "odometro", content: "" },
    { type: "frente", content: "" },
    { type: "traseira", content: "" },
    { type: "direita", content: "" },
    { type: "esquerda", content: "" },
  ],
  velotrackSettings: {
    deviceId: "",
    commands: [],
    nameDriver: "",
    lastComunication: "",
    blocked: false,
    blockedDate: null as unknown as Date,
  },
  partnerInfo: {
    _id: "",
    cnpj: "",
    companyName: "",
  },
  fipeInfo: {
    fipeValue: "",
    fipeVehicleCode: "",
    fuel: "",
    consultDate: "",
    authentication: "",
    brand: {
      label: "",
      fipeId: "",
    },
    model: {
      availableYears: [
        {
          label: "Zero KM",
          fipeId: "32000-1",
        },
      ],
      label: "",
      fipeId: "",
    },
    yearModel: {
      label: "Zero KM",
      fipeId: "32000-1",
    },
    reference: {
      label: "",
      fipeId: "",
    },
  },
  vehiclePreparing: {
    paintingProtection: false,
    tracker: false,
    cellphoneSupport: false,
    phoneChargerSupport: false,
    engineProtection: false,
    trackerValidation: false,
    crlvDocument: false,
    hasSpareKey: false,
    nfDocument: false,
    insuranceStatus: false,
    preparator: "",
    repreparator: "",
    preparation: {},
    repreparation: {},
  },
  status: VEHICLE_STATUS.UNDEFINED,
  vehicleSituation: "",
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
  observations: [],
  fineUpload: [],
  isEligibleSuaVibe: false,
  uf: "",
});
